import React from "react";
import { useDroppable } from "@dnd-kit/react";

interface DroppableLaneProps {
    ruleIndex: number;
    lane: "include" | "exclude";
    children: React.ReactNode;
    onClick?: () => void;
}

export const DroppableLane: React.FC<DroppableLaneProps> = ({ ruleIndex, lane, children, onClick }) => {
    const { ref, isDropTarget } = useDroppable({
        id: `lane-${ruleIndex}-${lane}`,
        data: { ruleIndex, lane },
    });

    return (
        <div
            ref={ref as any}
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => e.key === "Enter" && onClick?.()}
            style={{
                minHeight: 60,
                padding: 12,
                border: `1px dashed ${isDropTarget ? "#1890ff" : "#d9d9d9"}`,
                borderRadius: 8,
                background: isDropTarget ? "#e6f7ff" : "#fafafa",
            }}
        >
            {children}
        </div>
    );
}
